import React from 'react';
import { NavLink } from 'react-router-dom';
import { Button } from '@mui/material';
// import { DefaultRouteProps } from '@trurisk/core/commonTypes';
// import signOut from '@trurisk/core/authentication/signOut';
// import { Environment } from '@trurisk/core/commonTypes/environment';
// import { DefaultRouteProps, AppContext } from '../../commonTypes';
// import { services, serviceLinks, serviceLinksLocal } from '../../constants/enums';
import signOut from '../../authentication/signOut';
import './SomthingWentWrongPage.scss';
const SomthingWentWrongPage = ({ environment, t }) => (
// const links = environment.local ? serviceLinksLocal : serviceLinks;
// const cookies = new Cookies();
// const navigate = (destination: number) => {
//   cookies.set('trurisk_service', destination);
//   window.location.href = links[destination] as string;
// };
React.createElement("div", { className: "somthing-page-wrapper" },
    React.createElement("div", { className: "somthing-page-container" },
        React.createElement("p", null, t('Somthing went wrong!')),
        environment.env === 'preprod' ? React.createElement("p", null, t('Turn on your VPN!')) : '',
        React.createElement("p", null, t('Try refreshing the page or log out.')),
        React.createElement(Button, { variant: "outlined", size: "medium", onClick: () => window.location.reload() }, t('Refresh')),
        React.createElement(NavLink, { to: "/auth", onClick: () => signOut(environment) }, t('Logout')))));
export default SomthingWentWrongPage;
